import Layout from '@/layout/index.vue'
import TrackingEvent from '@/plugins/tracking/event'
import locator from '@/service-locator'
import { getLanguageFromLocale } from '@/utils/i18n'
import { getToken } from '@/utils/auth'
import { redirectToOnboardingV3 } from '@/utils/onboarding-session'
// ABT provider for feature gate checks
import { getABTProvider } from '@/plugins/abt/statsig'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all permissions can be accessed
 */
export default [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index.vue'),
      },
    ],
  },
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true,
    meta: {
      pageEvent: TrackingEvent.page_view.login_page_viewed,
    },
    beforeEnter: (_, __, next) => {
      locator.tracking.reset()

      const detectedLang = getLanguageFromLocale(
        locator.store.getters.currentLocale
      )

      locator.sfChatbot.initChatBot({ language: detectedLang })
      next()
    },
  },
  {
    path: '/onboarding',
    component: () => import('@/views/onboarding/index.vue'),
    hidden: true,
    beforeEnter: (to, _, next) => {
      const abtProvider = getABTProvider()
      const utmSource = to.query.utm_source
      const allowedStayOnV2UtmSources =
        abtProvider.getConfigurations(
          'config_utm_source_redirect_bypass_allowlist'
        )?.value || []
      const isAllowedStayOnV2 =
        allowedStayOnV2UtmSources?.includes?.(utmSource) || false

      // If user is not logged in, redirect to onboarding v3
      // unless the utm_source is in the disabled list
      if (!getToken() && !isAllowedStayOnV2) {
        redirectToOnboardingV3()

        return
      }

      // If user is logged in, redirect user to onboarding form
      next()
    },
  },
  {
    path: '/user-email-verification',
    component: () => import('@/views/authentication/SetPasswordPage.vue'),
    hidden: true,
    props: {
      setPasswordType: 'activated',
    },
  },
  {
    path: '/forgot-password',
    component: () => import('@/views/authentication/ForgotPasswordPage.vue'),
    hidden: true,
  },
  {
    path: '/reset-password',
    component: () => import('@/views/authentication/SetPasswordPage.vue'),
    hidden: true,
    props: {
      setPasswordType: 'reset',
    },
  },
  {
    path: '/chatbot',
    name: 'chatbot',
    component: () => import('@/views/chatbot/index.vue'),
    hidden: true,
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true,
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true,
  },
  {
    path: '/',
    component: Layout,
    hidden: true,
    redirect: '/dashboard/home',
  },
  // // 404 page must be placed at the end !!!
  // { path: '*', redirect: '/404', hidden: true },
]
